<template>
    <div :class="className">
        <h1 class="heading-border-bottom-anim" v-if="title">
            {{title}}
        </h1>
        <div class="sidebar-trending-questions">
            <div class="sidebar-trending-qst" v-for="(item, i) in lists" :key="i">
                <h1><router-link :to="item.path">{{item.title}}</router-link></h1>
                <small class="meta">{{item.date}} . by <a href="#">{{item.user}}</a></small>
            </div>

        </div>
    </div>
</template>

<script>

export default {
    name: 'TrendingQuestions',
    props: {
        title: {
            type: String,
            default: 'Related Questions'
        },
        lists: {
            type: Array,
            default: () => {}
        },
        className: {
            type: String,
            default: 'sidebar-card'
        }
    },
    data() {
        return {
            
        }
    }
}
</script>